// src/components/dashboard/MobileNavBar/MobileNavBar.jsx
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  SparklesIcon,
  DocumentTextIcon,
  BriefcaseIcon,
  AdjustmentsHorizontalIcon,
  EnvelopeIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";

const MobileNavBar = () => {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);

  const navItems = [
    {
      path: "/dashboard/ai-matchmaking",
      label: "Career Path",
      icon: <SparklesIcon className="nav-icon" />,
    },
    {
      path: "/dashboard/resume-builder",
      label: "Resume Builder",
      icon: <DocumentTextIcon className="nav-icon" />,
    },
    {
      path: "/dashboard/job-listing",
      label: "Job Listing",
      icon: <BriefcaseIcon className="nav-icon" />,
    },
    {
      path: "/dashboard/resume-optimization",
      label: "Resume Optimization",
      icon: <AdjustmentsHorizontalIcon className="nav-icon" />,
    },
    {
      path: "/dashboard/cover-letter",
      label: "Cover Letter",
      icon: <EnvelopeIcon className="nav-icon" />,
    },
    {
      path: "/profile-setup",
      label: "Profile Management",
      icon: <UserCircleIcon className="nav-icon" />,
    },
  ];

  return (
    <nav className="smai-mobile-nav-bar">
      <div className="smai-mobile-nav-items">
        {navItems.map((item, index) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `smai-mobile-nav-item ${isActive ? "active" : ""}`
            }
            onMouseEnter={() => setHoveredItem(index)}
            onMouseLeave={() => setHoveredItem(null)}
            onTouchStart={() => setHoveredItem(index)}
            onTouchEnd={() => setTimeout(() => setHoveredItem(null), 1000)}
          >
            {item.icon}
            {hoveredItem === index && (
              <span className="smai-nav-tooltip">{item.label}</span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileNavBar;
